import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import MentionEditor, {
  IMentionEditorModuleProps,
  IMentionEditorUIProps,
} from '../components/MentionEditor'
import * as MentionEditorModule from '../modules/mentionEditor'

export default connect(
  (state: ApplicationState, ownProps: IMentionEditorUIProps) =>
    createStructuredSelector<ApplicationState, IMentionEditorModuleProps>({
      suggestions: MentionEditorModule.selectSuggestions(ownProps.id),
    }),
  MentionEditorModule.actionCreators,
)(MentionEditor)
